export default {
  // Job types card
  jobTypesTitle: 'Job types',
  jobTypesDescription: 'Categories for jobs, such as "Night works" or "Callout". Pick one on a job, and limit a reminder profile to some of them.',
  jobTypeName: 'Job type name',
  jobTypePlaceholder: 'e.g. Night works',
  addJobType: 'Add job type',
  renameJobType: 'Rename {name}',
  deleteJobTypeLabel: 'Delete {name}',
  noJobTypes: 'No job types yet',
  noJobTypesHint: 'Add one below, then choose it on a job.',
  jobTypeAdded: 'Job type added.',
  jobTypeRenamed: 'Job type renamed.',
  jobTypeDeleted: 'Job type deleted.',
  deleteJobTypeTitle: 'Delete this job type?',
  deleteJobTypeMessage: 'Jobs using "{name}" will have no job type. This can\'t be undone.',

  // Profiles card
  profilesTitle: 'Shift & job reminders',
  profilesDescription:
    "App notifications before a shift or job starts. Each profile applies to the employee types and job types you choose, and profiles that match add up. Each phone sets its own reminders, so a change reaches an employee's phone the next time their app syncs, within a few hours.",
  newProfile: 'New profile',
  editProfile: 'Edit profile',
  openProfile: 'Edit {name}',
  disabled: 'Off',
  noProfiles: 'No reminder profiles yet',
  noProfilesHint: 'Create a profile to remind people the night before, the morning of, or when they should be on site.',
  everyone: 'Everyone',
  anyJobAndShifts: 'any job, and shifts',
  scopeSummary: 'Employee types: {employees} · Job types: {jobs}',

  // Profile dialog
  profileDialogDescription: 'Choose who this applies to, then add the reminders.',
  profileName: 'Profile name',
  profileNamePlaceholder: 'e.g. Labour hire',
  profileEnabled: 'Send these reminders',
  employeeTypes: 'Employee types',
  employeeTypesHint: 'Leave all unticked to apply to everyone. Matches the Employment type on each employee.',
  jobTypes: 'Job types',
  jobTypesHint: 'Leave all unticked to apply to every job and to shifts.',
  jobTypesNoneYet: 'No job types yet. Add some in the Job types card, then tick them here.',
  jobTypesNoShifts: 'Shifts have no job type, so this profile will only apply to jobs of these types.',
  remindersHeading: 'Reminders',
  addReminder: 'Add reminder',
  removeReminder: 'Remove reminder',
  deleteProfile: 'Delete profile',
  deleteProfileTitle: 'Delete this profile?',
  deleteProfileMessage: 'Employees will stop getting the reminders in "{name}". This can\'t be undone.',
  profileSaved: 'Reminder profile saved.',
  profileDeleted: 'Reminder profile deleted.',

  // Reminder editor
  kindLabel: 'When',
  kindRelative: 'Relative to the start',
  kindClock: 'At a set time of day',
  amountLabel: 'Amount',
  unitLabel: 'Unit',
  unitMinutes: 'minutes',
  unitHours: 'hours',
  unitDays: 'days',
  directionLabel: 'Before or after',
  directionBefore: 'before the start',
  directionAfter: 'after the start',
  timeLabel: 'Time (site time)',
  dayLabel: 'On',
  onStartDay: 'the start day',
  dayBefore: 'the day before',
  nDaysBefore: '{count} days before',
  required: 'Required',
  requiredHint: 'Employees can\'t switch this reminder off.',
  skipIfOnSite: 'Skip if already on site',
  skipIfOnSiteHint: 'Not sent to someone who is already checked in at the site.',
  problemTime: 'Enter the time as HH:mm.',
  problemAmount: 'Enter a whole number of minutes, hours or days.',
  problemTooEarly: 'A reminder can be at most 7 days before the start.',
  problemTooLate: 'A reminder can be at most 12 hours after the start.',

  // Preview
  previewTitle: 'When these would be sent',
  previewStart: 'Shift starts at',
  previewEmpty: 'Fix the reminders above to see when they would be sent.',
  previewNote: 'Shown for a shift starting on a Friday. Times are the site\'s local time.',
  neverFires: 'Never (after the start)',

  // Wording
  descAtStart: 'At the start',
  descBefore: '{amount} before the start',
  descAfter: '{amount} after the start',
  descClockSameDay: '{time} on the start day',
  descClockNightBefore: '{time} the night before',
  descClockDaysBefore: '{time}, {days} days before',
  minutesOne: '{count} minute',
  minutesOther: '{count} minutes',
  hoursOne: '{count} hour',
  hoursOther: '{count} hours',
  daysOne: '{count} day',
  daysOther: '{count} days',
}
